import { List } from 'lucide-react'
import TrBtn from './TrBtn'

const ViewClubButton = ({ action }) => {
  return (
    <TrBtn
      text='View'
      action={action}
    >
      <List size={15} />
    </TrBtn>
  )
}

export default ViewClubButton